import { Services } from 'shared/domain/messages/message';
import { broadcastAllIssues } from 'serviceWorker/broadcasts/issues';
import * as issues from 'serviceWorker/db/issues/issues';
import * as issuesService from 'serviceWorker/db/issues/issuesService';
import { issueContract } from 'shared/domain/issue/issueContract';
import { createSyncedEntity } from '../factories/createSyncedEntity';
import { fetchIssuesPaged, fetchUpdatedIssues } from './fetchIssues';

/**
 * Download (page by page) and incremental sync of the issues; the source's
 * `sync` is its entry point.
 */
export const issuesSync = createSyncedEntity({
  entityName: Services.ISSUES,
  contract: issueContract,
  // A download clears the issues and their documents only: the pull resets the download state itself.
  repository: { ...issues, clear: issues.clearForPull },
  service: issuesService,
  fetchPaged: fetchIssuesPaged,
  fetchUpdated: fetchUpdatedIssues,
  publishCollection: broadcastAllIssues,
});

// Direct-call model (PT-6899): kept for initAllServices bootstrap ordering.
export const init = (): void => {};
